import React from "react";
const SvgGear = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      style={{
        stroke: "none"
      }}
      d="M10 6.087a3.914 3.914 0 10.002 7.828A3.914 3.914 0 0010 6.087zm4.04-3.352l1.92-.914 2.22 2.219-.916 1.92a7.65 7.65 0 01.725 1.763L20 8.437v3.126l-2.011.714a7.65 7.65 0 01-.725 1.763l.915 1.92-2.219 2.22-1.92-.916a7.67 7.67 0 01-1.763.725L11.563 20H8.437l-.715-2.011a7.625 7.625 0 01-1.762-.725l-1.92.915-2.22-2.219.915-1.92a7.622 7.622 0 01-.724-1.763L0 11.563V8.437l2.011-.714a7.586 7.586 0 01.724-1.763L1.82 4.04l2.22-2.22 1.92.915a7.623 7.623 0 011.762-.724L8.437 0h3.126l.714 2.011a7.648 7.648 0 011.763.724z"
    />
  </svg>
);
export default SvgGear;
